<template>
	<div>
		<img class="gallery__placeholder" :src="placeholder" v-if="!data.gallery_absolute.length">
		<div class="gallery" ref="gallery" v-if="data.gallery_absolute.length">
			<vue-glide
				ref="slider"
				v-model="active"
				type="carousel"
				:perView="perView"
				:animationDuration="animationDuration"
				:autoplay="autoplay"
				:hoverpause="hoverpause"
			>
				<vue-glide-slide v-for="(image, imageIndex) in data.gallery_absolute" :key="imageIndex">
					<div
						ref="gallerySlider"
						class="images-wrapper"
						:style="{ backgroundImage: 'url(' + image + ')' }"
						@click="index = imageIndex"
					>
					</div>
					<span class="images-wrapper__counter">{{ imageIndex + 1}} / {{ data.gallery_absolute.length }}</span>
				</vue-glide-slide>
			</vue-glide>
			<div class="gallery__btn" ref="galleryBtn">
				<button class="btn btn--mdl" :id="galleryId">
					<SvgIcon class="gallery__icon" iconName="ico-gallery"/>
					<span class="gallery__btn-text">
						Open Gallery
					</span>
				</button>
			</div>

			<CoolLightBox 
				thumbsPosition='bottom'
				showFooterCount="true"
				:slideShow="true"
				:fullScreen="fullScreen"
				:gallery="true"
				ref="galleryCoolLight"
				:items="data.gallery_absolute" 
				:index="index"
				:overlayColor="overlayColor"
				:useZoomBar="true"
				:enableWheelEvent="enableWheelEvent"
				:effect="'fade'"
				@on-open="counter"
				@on-change="changeIndex"
				@close="onClose">
			</CoolLightBox>
			<span class="cool-light-box__counter">
				{{ currentPhoto ? currentPhoto : index + 1}} / {{ data.gallery_absolute.length }}
			</span>
		</div>
	</div>
</template>

<script>
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import CoolLightBox from 'vue-cool-lightbox';
import { Glide, GlideSlide } from 'vue-glide-js';
import 'vue-glide-js/dist/vue-glide.css';
import { mixin as onClickOutside } from 'vue-on-click-outside';
import { getDemoAsset } from '@/config/util';

export default {
	props: {
		data: {
			type: Object,
			required: true
		}
	},
	components: {
		SvgIcon,
		CoolLightBox,
		[Glide.name]: Glide,
		[GlideSlide.name]: GlideSlide
	},
	data () {
		return {
			placeholder: getDemoAsset('gallery/placeholder-gallery.jpg'),
			autoplay: true,
			hoverpause: true,
			active: 1,
			perView: 1,
			animationDuration: 5000,
			fullScreen: true,
			enableWheelEvent: true,
			overlayColor: '#333',
			index: null,
			galleryId: 'gallery-button',
			currentPhoto: null
		};
	},
	mixins: [onClickOutside],
	watch: {
	},
	methods: {
		counter() {
			this.$refs.gallery.classList.add('show-counter');
		},
		changeIndex(index) {
			this.currentPhoto = index + 1;
		},
		onClose() {
			this.index = null;
			this.autoplay = true;
			this.$refs.gallery.classList.remove('show-counter');
		}
	}
};
</script>

<style lang="scss" scoped>
.show-counter {
	.cool-light-box__counter {
		opacity: 1;
		visibility: visible;
	}
}
.cool-light-box__counter {
	position: fixed;
    z-index: 999999;
    display: block;
    top: 10px;
    left: 15px;
	color: $white;
	font-size: 14px;
	font-family: $font-main;
	opacity: 0;
	visibility: hidden;
	pointer-events: none;
	transition: $dur $ease;

	&.show {
		display: block;
	}
}

.images-wrapper__counter {
	font-family: $font-main;
	font-size: 14px;
	line-height: 1.2;
	position: absolute;
	right: 5px;
    bottom: 0;
    padding: 11px 9px 8px;
	background-color: $athens-gray;
}

.gallery__btn {
	position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	opacity: 0;
	visibility: hidden;
	transition: $dur $ease;
	z-index: 3;
	pointer-events: none;

	@include mq($xl) {
		top: auto;
		transform: none;
		bottom: 0;
		left: 0;
		opacity: 1;
		visibility: visible;

		.gallery__btn-text {
			display: none;
		}

	}
	#gallery-button {
		min-width: auto;
	}
}

.gallery {
	@include hover {
		.gallery__btn  {
			opacity: 1;
			visibility: visible;
			pointer-events: none;
		}

		.images-wrapper {
			filter: blur(1px);
		}
	}
}

.gallery__icon {
    font-size: 31px;
    margin-right: 5px;

	@include mq($xl) {
		margin-right: 0;
	}
}

.images-wrapper {
	// height: 363px !important;//sass-lint:disable-line no-important
	object-fit: contain;
	cursor: pointer;
	width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
	position: relative;
	background-color: $white;
	transition: $dur $ease;

	// @include mq($sm) {
	// 	height: 300px !important;//sass-lint:disable-line no-important
	// }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.gallery__placeholder {
	min-height: 363px;
	max-height: 363px;
	max-width: 100%;
	object-fit: none;
	width: 100%;

	@include mq($lg) {
		// min-height: auto;
	}

	@include mq($sm) {
		min-height: 300px;
		max-height: 300px;
	}
}
</style>
